var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"tw-w-full tw-ml-auto tw-mr-auto c-container",class:{
    'sm:tw-max-w-[750px] md:tw-max-w-[960px] lg:tw-max-w-[1200px] ': !_vm.fluid,
    'sm:tw-px-3 tw-px-4': !_vm.noPadding
  }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }